export enum MetricsDataKeys {
  UrlID = 'url_id',
  Url = 'url',
  Comparison = 'comparison',
  Quantifier = 'quantifier',
  Deviation = 'deviation',
}
